import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideArrowDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v14m7-7-7 7-7-7"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideArrowDown);
const Memo = memo(ForwardRef);
export default Memo;
